module.exports = __webpack_public_path__ + "img/43.f10baf30.png";